import { render, staticRenderFns } from "./PrintAdmissionReport.vue?vue&type=template&id=08a72752&"
import script from "./PrintAdmissionReport.vue?vue&type=script&lang=js&"
export * from "./PrintAdmissionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports